export enum REPORTS_PERMISSIONS {
  REPORT_ADMIN_SUMMARY = 'REPORT_ADMINSUMMARY',
  REPORT_SEO_AUDIT = 'REPORT_SEOAUDIT',
  REPORT_CLIENTS = 'REPORT_CLIENTS',
  REPORT_LOGISTIC_LOCATION = 'REPORT_LOGISTICLOCATION',
  REPORT_PRODUCT = 'REPORT_PRODUCT',
  REPORT_PRODUCT_ROTATION = 'REPORT_PRODUCTROTATIONVIEW',
  REPORT_INCIDENCES = 'REPORT_INCIDENCES',
  REPORT_OFFERS = 'REPORT_OFFERS',
  REPORT_ORDERS_PAID = 'REPORT_ORDERSPAID',
  REPORT_CONCILIATION = 'REPORT_CONCILIATIONVIEW',
  REPORT_INVENTORY_FLOWS = 'REPORT_INVENTORY_FLOWS',
  REPORT_INVENTORY_COVERAGE = 'REPORT_INVENTORY_COVERAGE',
  REPORT_INVENTORY_RISK = 'REPORT_INVENTORY_RISK',
  REPORT_PRODUCT_SCORE = 'REPORT_PRODUCT_SCORE',

  PAYMENT_OPS_REPORT_READ = 'PAYMENT_OPSREPORTREAD',
  PAYMENT_BIZ_REPORT_READ = 'PAYMENT_BIZREPORTREAD',
  PAYMENT_CALLBACK_READ = 'PAYMENT_CALLBACKREAD',

  REPORT_SALES = 'REPORT_SALES',
  REPORT_CANCELLED_ORDERS_READ = 'REPORT_CANCELLED_ORDERS_READ',

  REPORT_SUPPLIER_SUMMARY = 'REPORT_SUPPLIER_SUMMARY',

  INTEGRATION_DASHBOARD_READ = 'INTEGRATION_DASHBOARD_READ',
  INTEGRATION_DASHBOARD_RETRY = 'INTEGRATION_DASHBOARD_RETRY',
  INTEGRATION_ALERT_READ = 'INTEGRATION_ALERT_READ',
  INTEGRATION_ALERT_MANAGE = 'INTEGRATION_ALERT_MANAGE',

  REPORT_INVENTORY_OPERATION = 'REPORT_INVENTORY_OPERATION',
  REPORT_INVENTORY_REGIONAL_COVERAGE = 'REPORT_INVENTORY_REGIONAL_COVERAGE',

  REPORT_PROVIDER_EVALUATION = 'REPORT_PROVIDER_EVALUATION',
}
